import {Card, Stack, Typography, useTheme} from '@mui/material';
import {FontIconChevron, IconBadge} from '@resurs-internal/mui';
import {useTranslate} from 'hooks';

type MonthlyDepositCancelCardProps = {
  onClick: () => void;
};

export const MonthlyDepositCancelCard = ({
  onClick,
}: MonthlyDepositCancelCardProps) => {
  const theme = useTheme();
  const translate = useTranslate();

  return (
    <Card
      component={'button'}
      onClick={onClick}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        mb: theme.spacing(2),
        px: theme.spacing(2),
        py: theme.spacing(2),
        cursor: 'pointer',
      }}>
      <Stack direction={'row'} alignItems={'center'} spacing={2}>
        <IconBadge
          type={'font'}
          icon={['far', 'circle-xmark']}
          shape={'none'}
          color={theme.palette.error.main}
        />
        <Typography variant={'body1'} sx={{color: theme.palette.error.main}}>
          {translate('savings.deposit.monthly.cancel.action')}
        </Typography>
      </Stack>
      <FontIconChevron direction={'right'} />
    </Card>
  );
};
